import * as React from 'react'

export function EmployeesPage() {

  // ---------------------------------------------
  // Transformations
  // ---------------------------------------------
  // Render

  return (
    <div className={'employees-page'}>
      Lista de Colaboradores
    </div>
  )
}